const n = {
  name: "OnDemandMonitor",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 16V4L18 10L8 16ZM14.11 10L10 7.53V12.47L14.11 10Z" fill="currentColor"/>
<path d="M0 4C0 2.34772 1.34772 1 3 1H21C22.6523 1 24 2.34772 24 4V16C24 17.6523 22.6523 19 21 19H3C1.34772 19 0 17.6523 0 16V4ZM3 3C2.45228 3 2 3.45228 2 4V16C2 16.5477 2.45228 17 3 17H21C21.5477 17 22 16.5477 22 16V4C22 3.45228 21.5477 3 21 3H3Z" fill="currentColor"/>
<path d="M7 21H17V23H7V21Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as OnDemandMonitor
};
